import React from 'react';
import { toCamelCase } from '../utils/stringUtils'; // Add this import

const GroupFilter = ({
  allGroupNames,
  showAllGroups,
  toggleShowAllGroups,
  validGroupNames,
  groupCounts,
  expandedGroups,
  toggleGroupExpansion,
  filters,
  handleFilterChange,
  rows,
  validLocations,
  locationCounts,
}) => (
  <div>
    <h3 className="font-semibold mb-1 text-gray-700">Group</h3>
    <div className="space-y-1">
      {(showAllGroups ? allGroupNames : allGroupNames.slice(0, 3)).map((group) => {
        const isSelected = (filters.group || []).includes(group);
        const isValid = validGroupNames.has(group);
        const count = groupCounts[group] || 0;
        return (
          <div key={group} className="space-y-1">
            <label
              className={`flex justify-between items-center px-2 py-0.5 border rounded cursor-pointer text-xs ${
                isSelected
                  ? 'bg-blue-500 text-white'
                  : isValid
                  ? 'bg-gray-100 hover:bg-gray-200'
                  : 'bg-gray-200 text-gray-400 cursor-not-allowed'
              }`}
              style={{ minHeight: '2rem' }} // Ensures consistent button height
            >
              <div className="flex items-center min-w-0 truncate">
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleFilterChange('group', group)}
                  className="hidden"
                  disabled={!isValid && !isSelected}
                />
                <span className="truncate">{group} {isValid && `(${count})`}</span>
              </div>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  toggleGroupExpansion(group);
                }}
                className={`ml-2 text-xs flex-shrink-0 focus:outline-none text-gray-600 hover:text-gray-800`}
                disabled={!isValid}
                tabIndex={-1}
                style={{ lineHeight: 1, padding: 0, background: 'none', border: 'none' }}
              >
                <span
                  className={`transform transition-transform duration-200 inline-block ${
                    expandedGroups.has(group) ? 'rotate-180' : ''
                  }`}
                >
                  ▼
                </span>
              </button>
            </label>
            {expandedGroups.has(group) && (
              <div className="ml-4 mt-1 flex flex-wrap gap-1">
                {Array.from(new Set(rows.filter(r => toCamelCase(r.groupName) === group && r.venue).map(r => r.venue)))
                  .sort()
                  .map((venue) => {
                    const isVenueSelected = (filters.location || []).includes(venue);
                    const isVenueValid = validLocations.has(venue);
                    const venueCount = locationCounts[venue] || 0;
                    return (
                      <label
                        key={venue}
                        className={`px-2 py-0.5 border rounded cursor-pointer text-xs ${
                          isVenueSelected
                            ? 'bg-blue-500 text-white'
                            : isVenueValid
                            ? 'bg-gray-100 hover:bg-gray-200'
                            : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                        }`}
                      >
                        <input
                          type="checkbox"
                          checked={isVenueSelected}
                          onChange={() => handleFilterChange('location', venue)}
                          className="hidden"
                          disabled={!isVenueValid && !isVenueSelected}
                        />
                        {venue} {isVenueValid && `(${venueCount})`}
                      </label>
                    );
                  })}
              </div>
            )}
          </div>
        );
      })}
      {allGroupNames.length > 3 && (
        <div className="flex justify-center mt-2">
          <button
            type="button"
            className="px-2 py-0.5 border rounded bg-gray-100 hover:bg-gray-200 text-gray-600 text-xs"
            onClick={toggleShowAllGroups}
          >
            {showAllGroups ? 'Show Less Groups' : `Show More Groups (${allGroupNames.length - 3} more)`}
          </button>
        </div>
      )}
    </div>
  </div>
);

export default GroupFilter;
